import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_AREAS_CONHECIMENTO,
  GET_DISCIPLINAS_POR_AREA
} from 'constants/ActionTypes';
import {
  listaAreasConhecimentoSucesso,
  getDisciplinasPorAreaSuccess
} from 'actions/AreaConhecimento';
import { showMessage } from 'actions/SeriesEscola';
import requisicaoApi from 'util/Api';

function* listaAreasConhecimento() {
  try {
    const response = yield call(requisicaoApi.get, '/areas-conhecimento');
    if (response.status === 200) {
      yield put(listaAreasConhecimentoSucesso(response.data));
    }
  } catch (error) {
    console.error('Erro ao listar áreas de conhecimento:', error);
  }
}

function* getDisciplinasPorArea({ payload: areaId }) {
  try {
    // payload é o ID da área
    const response = yield call(requisicaoApi.get, `/areas-conhecimento/${areaId}/com-disciplinas`);
    if (response.status === 200) {
        // A resposta esperada é um array [{ id, nome, disciplinas: [...] }]
        const data = response.data;
        let disciplinas = [];
        
        if (Array.isArray(data) && data.length > 0) {
            disciplinas = data[0].disciplinas || [];
        } else if (data && data.disciplinas) {
             disciplinas = data.disciplinas;
        }

        yield put(getDisciplinasPorAreaSuccess(areaId, disciplinas));
    }
  } catch (error) {
    console.error(`Erro ao buscar disciplinas da área ${areaId}:`, error);
    yield put(showMessage('Erro ao buscar disciplinas da área.'));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(LISTA_AREAS_CONHECIMENTO, listaAreasConhecimento),
    takeEvery(GET_DISCIPLINAS_POR_AREA, getDisciplinasPorArea),
  ]);
}
